<template>
  <div class="input-group">
    <b-form-input
      v-model="value"
      lazy :placeholder="$t('enter-text')"
      :disabled="!isConnectionOk"
    />
  </div>
</template>

<script>
import BaseControlMixin from '@/components/controls/mixins/BaseControl';

export default {
  name: 'TextInput',
  mixins: [
    BaseControlMixin,
  ],
  data() {
    return {
      varsValue: this.vars[0].value,
    };
  },
  computed: {
    value: {
      get() {
        return this.getSingleVar.value;
      },
      set(value) {
        this.varsValue = value;
        if (this.$_.includes(['YR_NO_CITY', 'YR_NO_COUNTRY', 'YR_NO_REGION'], this.vars[0].name)) {
          this.handleControl(encodeURI(this.varsValue));
        } else {
          this.handleControl(this.varsValue);
        }
      },
    },
  },
};
</script>

<style scoped>

</style>
